import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'

export const detectUserType = (userid: string) => {
    if (userid.match('^\d+$')) {
        return "keck ID";
    } else if (userid.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
        return "email";
    } else if (userid.match('^[a-zA-Z]+')) {
        return "KOA UserId";
    } else {
        return ""
    }
}


//@ts-ignore
dayjs.extend(utc)
export function NextWatchDate(now_date = dayjs().utcOffset(-10)) {
    // const now_date = dayjs("2023-01-10 03:39").utcOffset(-10)
    // const now_date = 
    const lower_limit = dayjs(now_date.format("YYYY-MM-DD 02:00"))
    const upper_limit = dayjs(now_date.add(1, 'day').format("YYYY-MM-DD 02:00"))

    let next_day ;

    if ( Math.abs(now_date.diff(lower_limit, 'hours')) <= 8 ) {
        next_day = lower_limit
    }
    else {
        //  ( Math.abs(now_date.diff(upper_limit, 'hours')) <= 6 ) {
        next_day = upper_limit
    }

    return next_day.utcOffset(-10);
}


export function NextWatch(time_format: string) {
    // const now_date = dayjs("2023-01-10 03:39").utcOffset(-10)
    const now_date = dayjs().utcOffset(-10)
    const lower_limit = dayjs(now_date.format("YYYY-MM-DD 02:00"))
    const upper_limit = dayjs(now_date.add(1, 'day').format("YYYY-MM-DD 02:00"))

    let next_day ;
    
    // console.log( now_date.diff(lower_limit, 'hours') )
    // console.log( now_date.diff(upper_limit, 'hours') )
    // console.log( Math.abs(now_date.diff(lower_limit, 'hours')) )
    // console.log( Math.abs(now_date.diff(upper_limit, 'hours')) )

    if ( Math.abs(now_date.diff(lower_limit, 'hours')) <= 8 ) {
        next_day = lower_limit
    }
    else {
        //  ( Math.abs(now_date.diff(upper_limit, 'hours')) <= 6 ) {
        next_day = upper_limit
    }

    // console.log(`NOW - ${now_date.format('YY-MM-DD H:mm')}`)
    // console.log(`LOWER - ${lower_limit.format('YY-MM-DD H:mm')}`)
    // console.log(`UPPER - ${upper_limit.format('YY-MM-DD H:mm')}`)
    // console.log(`NEXTDAY - ${next_day.format('YY-MM-DD H:mm')}`)

    if (time_format === 'hours') {
        return (next_day.utcOffset(-10)?.diff(now_date, 'hours'));
    } else {
        // Return Minute Format
        return (next_day.utcOffset(-10)?.diff(now_date, 'minutes'));
    }
}